export const filterNonDigits = (val) => val.replace(/\D/g, '')

export const filterNonAlphabets = (val) => val.replace(/[^a-zA-Z]/g, '')

export const phoneNumberFormatter = (val) => val.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')

const phoneNumberRegex = /^(1-?)?(\d{3}[-\s]?|\(\d{3}\)[-\s]?)\d{3}[-\s]?\d{4}$/
export const isValidPhoneNumber = (val) => phoneNumberRegex.test(val)

const urlRegex = /^(https?:\/\/)?(www\.)?[a-z0-9]+\.[a-z]+(\/.*)?$/i
export const isValidUrl = (val) => urlRegex.test(val)

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const isValidEmail = (val) => emailRegex.test(val)
